import React from 'react';

import { List, Track } from './styled';

const SPEED = 1.5;

export default class Scrolling extends React.Component {
    constructor(props) {
        super(props);
        this.scrollingTrackRef = React.createRef();
        this.scrollingListRef = React.createRef();
    }

    componentDidMount() {
        if (window) {
            window.addEventListener('resize', this.transformOnResize);
        }
        const { translate } = this.props;
        if (translate) {
            this.transform(translate);
        }
    }

    componentWillUnmount() {
        if (window) {
            window.removeEventListener('resize', this.transformOnResize);
        }
    }

    componentDidUpdate(prevProps) {
        const { children, translate } = this.props;
        if (children !== prevProps.children) {
            this.transformOnResize();
        }
        if (translate !== prevProps.translate) {
            this.transform(translate);
        }
    }

    transform = (x) => {
        const list = this.scrollingListRef.current;
        if (list) {
            list.style.transform = `translateX(${x})`;
        }
    }

    setCursor = (isGrabbing) => {
        const sliderRef = this.scrollingListRef.current;
        if (sliderRef) {
            sliderRef.style.cursor = isGrabbing ? 'grabbing' : 'grab';
            sliderRef.style.userSelect = isGrabbing ? 'none' : 'auto';
        }
    }

    getCurrentTranslateX = () => {
        const list = this.scrollingListRef.current;
        if (list) {
            return parseInt((list.style.transform || '0').replace('translateX(', ''));
        }
    }

    getTrackWidth = () => {
        const list = this.scrollingListRef.current;
        return list ? list.clientWidth : 0;
    }

    transformOnResize = () => {
        const currentTransformX = this.getCurrentTranslateX();
        const transformX = (currentTransformX < 0) ? this.getTransformX(currentTransformX) : 0;
        this.transform(transformX);
    }

    getTransformX = (currentX) => {
        const list = this.scrollingListRef.current;
        const trackWidth = this.getTrackWidth();
        const lastChildOffset = list.lastChild.offsetLeft + list.lastChild.offsetWidth;
        const maxOffset = lastChildOffset - trackWidth;

        const transformX = (trackWidth < lastChildOffset && maxOffset > 0) ? Math.max(currentX, -maxOffset) : 0;

        return transformX + 'px';
    }

    move = (event, startX, startTransformX) => {
        event.preventDefault();
        const xCoord = event.type === 'touchmove' ? event.touches[0].clientX : event.pageX;
        const walk = xCoord - startX;
        this.setCursor(true);

        const transformX = this.getTransformX(Math.min(0, startTransformX + walk * SPEED));
        this.transform(transformX);
    }

    startDrag = (event) => {
        const startTransformX = this.getCurrentTranslateX();
        const startX = event.type === 'touchstart' ? event.touches[0].clientX : event.pageX;
        const ref = this.scrollingTrackRef.current;

        ref.onmousemove = (e) => this.move(e, startX, startTransformX);
        ref.ontouchmove = (e) => this.move(e, startX, startTransformX);
    }

    endDrag = () => {
        this.setCursor(false);
        const ref = this.scrollingTrackRef.current;
        if (typeof ref.onmousemove === 'function') {
            ref.onmousemove = null;
            ref.ontouchmove = null;
        }
    }

    render() {
        const { children, ...rest } = this.props;

        const dragNDropEvents = {
            onMouseDown: this.startDrag,
            onTouchStart: this.startDrag,
            onMouseUp: this.endDrag,
            onTouchEnd: this.endDrag,
            onMouseLeave: this.endDrag,
            onTouchCancel: this.endDrag,
        };

        return (
            <Track ref={this.scrollingTrackRef} {...dragNDropEvents} onDragStart={e => e.preventDefault()} {...rest}>
                <List ref={this.scrollingListRef}>
                    {children}
                </List>
            </Track>
        );
    }
}
